export const FOOTER_LABELS = {
  Market: 'FOOTER.ALL_PAGES.NAVIGATION.METRO.LABEL',
  AboutUs: 'FOOTER.ALL_PAGES.NAVIGATION.MARKET.ABOUT_US.LABEL',
  Careers: 'FOOTER.ALL_PAGES.NAVIGATION.MARKET.CAREERS.LABEL',
  Buyers: 'FOOTER.ALL_PAGES.NAVIGATION.FOR_BUYERS.LABEL',
  OrderInfo: 'FOOTER.ALL_PAGES.NAVIGATION.BUYER.ORDER_INFO.LABEL',
  ShippingInfo: 'FOOTER.ALL_PAGES.NAVIGATION.BUYER.SHIPPING_INFO.LABEL',
  ReturnPolicy: 'FOOTER.ALL_PAGES.NAVIGATION.BUYER.RETURN_POLICY.LABEL',
  HelpCenter: 'FOOTER.ALL_PAGES.NAVIGATION.CONTACTS.HELP_CENTER.LABEL',
  SellerHelpCenter:'FOOTER.ALL_PAGES.NAVIGATION.CONTACTS.BUYER_HELP_CENTER.LABEL',
  FAQ: 'FOOTER.ALL_PAGES.NAVIGATION.FAQ.LABEL',
  Sellers: 'FOOTER.ALL_PAGES.NAVIGATION.FOR_SELLERS.LABEL',
  StartSelling: 'FOOTER.ALL_PAGES.NAVIGATION.SELLER.START_SELLING.LABEL',
  DiscountCode: 'FOOTER.ALL_PAGES.NAVIGATION.BUYER.DISCOUNT_CODE.LABEL',
  Offers: 'FOOTER.ALL_PAGES.NAVIGATION.BUYER.OFFERS.LABEL',
  ComplaintBook: 'FOOTER.ALL_PAGES.NAVIGATION.COMPLAINT_BOOK.LABEL',
};
